const initSlideshowInPage = () => {
  const slideContainers = document.querySelectorAll('[data-slideshow]');

  slideContainers.forEach(slideContainer => {
    const imagesCount = slideContainer.querySelectorAll('img').length;
    $(slideContainer).slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      transitionDuration: 1000,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      fade: true,
      arrows: imagesCount > 1,
      prevArrow: '<span class="icon-prev prev"></span>',
      nextArrow: '<span class="icon-next next"></span>',
      responsive: [],
    });
  });
};

initSlideshowInPage();
